<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">
    <div class="form-section">
      <app-form-row [label]="'FORMS.RFP.RECIPIENT' | translateControl : form | async">
        <app-dropdown [options]="dropdownData.manufacturers" [labelKey]="'title'" [valueKey]="'value'" [mainForm]="form"
          [controlName]="'email'">
        </app-dropdown>
      </app-form-row>
      <app-form-row [label]="'FORMS.RFP.MESSAGE' | translateControl : form | async">
      </app-form-row>
      <app-textarea [mainForm]="form" [controlName]="'message'">
      </app-textarea>
    </div>
  </div>
</form>
